import { ProgramService } from "@adfenix/types";
import { CustomFormKey, BundleFormKey } from "../util/formKey";
import { groupAndSortNotifications } from "./notificationHelper";
import { Notification } from "./Notification";
import { Card } from "@adfenix/alexandria";
import Divider from "components/Divider";
import { Fragment } from "react";

interface Props {
  baseKey: CustomFormKey | BundleFormKey;
  emails: ProgramService.ProgramEmailModel[] | undefined | null;
  tickets: ProgramService.ProgramTicketModel[] | undefined | null;
  wrapCard?: boolean;
}
export const NotificationList = ({
  baseKey,
  emails,
  tickets,
  wrapCard = false
}: Props) => {
  const emailsOrDefault = emails ?? [];
  const ticketsOrDefault = tickets ?? [];
  const notifications = groupAndSortNotifications(
    emailsOrDefault,
    ticketsOrDefault
  );

  return notifications.map(({ type, ...notification }) => {
    const props = {
      baseKey,
      tickets: ticketsOrDefault,
      emails: emailsOrDefault
    };

    const NotificationComponent =
      type === "email" ? (
        <Notification
          {...props}
          notification={notification as ProgramService.ProgramEmailModel}
          notificationKey={`${baseKey}.emails.${emailsOrDefault.findIndex(
            x => x.id === notification.id
          )}`}
          type="email"
        />
      ) : (
        <Notification
          {...props}
          notification={notification as ProgramService.ProgramTicketModel}
          notificationKey={`${baseKey}.tickets.${ticketsOrDefault.findIndex(
            x => x.id === notification.id
          )}`}
          type="ticket"
        />
      );

    return wrapCard ? (
      <Card key={notification.id}>{NotificationComponent}</Card>
    ) : (
      <Fragment key={notification.id}>
        {NotificationComponent}
        <Divider margin="20px 0 16px 0" />
      </Fragment>
    );
  });
};
